import { render, staticRenderFns } from "./TheInvoices.vue?vue&type=template&id=31ca0a16&scoped=true"
import script from "./TheInvoices.vue?vue&type=script&lang=js"
export * from "./TheInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca0a16",
  null
  
)

export default component.exports